import axios from '@/api/config';

const system = {
  login(data) {
    return axios.post(`${process.env.BASE_URL}/system/login`, data);
  },
  getSMSCode(data) {
    return axios.post(`${process.env.BASE_URL}/system/getSMSCode`, data);
  },
  resetPassword(data) {
    return axios.post(`${process.env.BASE_URL}/system/resetPassword`, data);
  },
  checkSMSCode(data) {
    return axios.post(`${process.env.BASE_URL}/system/checkSMSCode`, data);
  },
}

export default system;



// WEBPACK FOOTER //
// ./src/api/system.js